module.exports = __webpack_public_path__ + "img/san_francisco_tramway.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/san_francisco_tramway.jpg
// module id = 3
// module chunks = 0